module.exports = __webpack_public_path__ + "static/media/spinner_logo.da765c10.svg";